import { render, staticRenderFns } from "./Episode2.vue?vue&type=template&id=5d6a53e4&"
import script from "./Episode2.vue?vue&type=script&lang=js&"
export * from "./Episode2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports